import { UpdateWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Update')
export class UpdateConnectorProvider extends ConnectorProvider<UpdateWorkflowNode> {}
